export const VIDEOJS_OPTIONS = {
  fluid: true,
  autoplay: false,
  controls: true,
  preload: "auto",
  controlBar: {
    pictureInPictureToggle: true,
    currentTimeDisplay: true,
  },
  playbackRates: [0.5, 1, 1.5, 2],
  html5: {
    nativeAudioTracks: false,
    nativeVideoTracks: false,
  },
};
